import React from 'react';
import { Image } from 'react-feather';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import NextImage from 'next/image';

import Button from '../../buttons/Button';
import FallbackImage from '../../FallbackImage';
import { DisplayImage } from 'components/poi/PoiMediaGallery';

SwiperCore.use([Navigation]);

function MobileSwipeGallery({ images, handleClick }: { images: DisplayImage[]; handleClick: (index: number) => void }) {
    return (
        <div className="relative h-full">
            {images.length === 0 && <FallbackImage />}

            {images.length > 0 && (
                <Swiper
                    loop
                    spaceBetween={0}
                    slidesPerView={1}
                    navigation
                    preloadImages={false}
                    cssMode
                    className="h-full rounded-xl overflow-hidden"
                >
                    {images.map((image, i) => (
                        <SwiperSlide key={i} className="w-full h-full bg-gray-100">
                            <NextImage
                                src={image.medium.url}
                                loading="lazy"
                                unoptimized
                                alt={image.alt}
                                className="w-full h-full object-cover"
                                onClick={() => handleClick(i + 1)}
                                fill
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
            <div className="absolute bottom-2 right-2 z-10">
                <Button onClick={() => handleClick(1)} startIcon={<Image />} color="white">
                    Galerija
                </Button>
            </div>
        </div>
    );
}

export default MobileSwipeGallery;
